import type { Connection } from '../types';

export const CONNECTIONS: Connection[] = [
	{
		id: 8,
		provider: 'SendGrid',
		logo: 'SG',
		cred: '•••• 9x3z',
		label: 'Marketing',
		type: 'Email',
		status: 'Active',
		region: 'Global',
		created: 'Apr 27, 2026',
		clientName: 'smart_app_consumer',
	},
	{
		id: 7,
		provider: 'SendGrid',
		logo: 'SG',
		cred: '•••• 4f2a',
		label: 'Transactional',
		type: 'Email',
		status: 'Active',
		region: 'Global',
		created: 'Apr 20, 2026',
		clientName: 'smart_app_consumer',
	},
	{
		id: 6,
		provider: 'Mailgun',
		logo: 'MG',
		cred: '•••• 9c1b',
		label: 'Backup',
		type: 'Email',
		status: 'Inactive',
		region: 'US',
		created: 'Apr 18, 2026',
		clientName: 'smart_app_merchant',
	},
	{
		id: 5,
		provider: 'AWS SES',
		logo: 'SES',
		cred: '•••• 2e8f',
		label: 'Emergency',
		type: 'Email',
		status: 'Error',
		region: 'ap-south-1',
		created: 'Apr 10, 2026',
		clientName: 'smart_app_consumer',
	},
	{
		id: 4,
		provider: 'FCM',
		logo: 'FCM',
		cred: '•••• 7d3c',
		label: 'Android Push',
		type: 'Push',
		status: 'Active',
		region: 'Global',
		created: 'Apr 08, 2026',
		clientName: 'smart_app_mobile',
	},
	{
		id: 3,
		provider: 'APNs',
		logo: 'APNs',
		cred: '•••• 3a9d',
		label: 'iOS Push',
		type: 'Push',
		status: 'Active',
		region: 'Global',
		created: 'Apr 08, 2026',
		clientName: 'smart_app_mobile',
	},
	{
		id: 2,
		provider: 'Twilio',
		logo: 'TW',
		cred: '•••• 1a9f',
		label: 'Primary SMS',
		type: 'Sms',
		status: 'Active',
		region: 'IN',
		created: 'Apr 05, 2026',
		clientName: 'smart_app_consumer',
	},
	{
		id: 1,
		provider: 'Infobip',
		logo: 'IB',
		cred: '•••• 5b2e',
		label: 'SMS Fallback',
		type: 'Sms',
		status: 'Inactive',
		region: 'Global',
		created: 'Mar 28, 2026',
		clientName: 'smart_app_merchant',
	},
];
